import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import NavBar from '../components/NavBar';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';
import './Kariyer.css';

export default function Kariyer() {
  const submitting = useRef(false);
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (submitting.current) return;
    const data = Object.fromEntries(new FormData(event.currentTarget));
    const now = new Date();
    submitting.current = true;
    setStatus('sending');
    try {
      await emailjs.send('service_b7f5o1n', 'template_ak18qvo', {
        ...data,
        konu: 'Yeni Kariyer Başvurusu',
        from_name: data.ad_soyad,
        reply_to: data.eposta,
        tarih: now.toLocaleDateString('tr-TR'),
        saat: now.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' }),
      }, '-lphAVFUdhR2wrgTe');
      setStatus('success');
    } catch {
      setStatus('error');
    } finally {
      submitting.current = false;
    }
  };

  return (
    <>
      <TopBar />
      <NavBar />
      <main className="career-page">
        <header className="career-header">
          <span className="career-badge">Kariyer</span>
          <h1>Birlikte geleceğe değer katalım</h1>
          <p>Yeldeğirmeni Eğitim Kurumları ekibine katılmak için kariyer başvuru formunu doldurun.</p>
        </header>
        <section className="career-card" aria-labelledby="application-title">
          <h2 id="application-title">Kariyer Başvurusu</h2>
          {status === 'success' ? (
            <div role="status" className="career-success">
              <h3>Başvurunuz alındı</h3>
              <p>Kariyer başvurunuz başarıyla gönderildi. İlginiz için teşekkür ederiz.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} aria-busy={status === 'sending'}>
              <p>Öğretmenlik, idari kadro ve destek ekibi pozisyonları için bilgilerinizi paylaşabilirsiniz. * işaretli alanlar zorunludur.</p>
              <fieldset className="career-fields" disabled={status === 'sending'}>
                <div className="career-grid">
                  <label>Ad Soyad *<input name="ad_soyad" autoComplete="name" required maxLength={150} /></label>
                  <label>E-posta *<input name="eposta" type="email" autoComplete="email" required maxLength={254} /></label>
                  <label>Telefon *<input name="telefon" type="tel" autoComplete="tel" required maxLength={30} /></label>
                  <label>Pozisyon / Branş *<input name="pozisyon" placeholder="Örn. Sınıf Öğretmeni" required maxLength={150} /></label>
                </div>
                <label>Eğitim Bilgileri *<textarea name="egitim" rows={3} placeholder="Mezun olduğunuz okul, bölüm ve mezuniyet yılı" required maxLength={3000} /></label>
                <label>İş Deneyimi *<textarea name="deneyim" rows={4} placeholder="Çalıştığınız kurumlar ve görevleriniz. Deneyiminiz yoksa yeni mezun olduğunuzu belirtebilirsiniz." required maxLength={5000} /></label>
                <label>Özgeçmiş Bağlantısı (isteğe bağlı)<input name="cv_url" type="url" placeholder="https://..." maxLength={2000} aria-describedby="career-cv-help" /></label>
                <p id="career-cv-help" className="career-note">Özgeçmişinizin veya LinkedIn profilinizin erişilebilir bağlantısını ekleyebilirsiniz.</p>
                <label>Ön Yazı (isteğe bağlı)<textarea name="on_yazi" rows={4} placeholder="Kendinizden ve ekibimize katılma motivasyonunuzdan bahsedin." maxLength={5000} /></label>
                <label className="career-consent"><input name="basvuru_onayi" type="checkbox" required value="Onaylandı" /><span>Paylaştığım bilgilerin kariyer başvurumun değerlendirilmesi ve benimle iletişim kurulması amacıyla Yeldeğirmeni Eğitim Kurumları'na iletilmesini kabul ediyorum. *</span></label>
                {status === 'error' && <p role="alert" className="career-error">Başvurunuz gönderilemedi. Bilgileriniz korunuyor; lütfen tekrar deneyin.</p>}
                <button className="career-apply" type="submit" disabled={status === 'sending'}>{status === 'sending' ? 'Gönderiliyor…' : 'Başvuruyu Gönder'}</button>
              </fieldset>
            </form>
          )}
        </section>
      </main>
      <Footer />
    </>
  );
}
